import React from 'react';
import ReactDOM from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import './index.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from "react-router-dom";
import { init } from '@emailjs/browser';
import { HelmetProvider } from 'react-helmet-async';
import AOS from 'aos';
import 'aos/dist/aos.css';

// AOS animasyon kütüphanesini başlat
AOS.init({
  duration: 1000,
  once: true,  // Animasyonların sadece bir kez çalışmasını sağlar
  mirror: false, // Scroll yukarı yapıldığında ters animasyon çalışmaz
  offset: 50,  // Animasyonun başlama noktası (daha erken başlasın)
  easing: 'ease-out', // Daha yumuşak bir animasyon
  disable: false, // Animasyonları devre dışı bırakma
  startEvent: 'DOMContentLoaded', // DOM yüklendiğinde başlat
  initClassName: 'aos-init', // AOS başlatıldığında eklenen class
  animatedClassName: 'aos-animate', // Animasyon çalıştığında eklenen class
});

// EmailJS'i initialize et - Ortam değişkenini kullan
const emailJsPublicKey = process.env.REACT_APP_EMAILJS_PUBLIC_KEY;

// Public key varsa EmailJS'i başlat, yoksa konsola hata mesajı yaz
if (emailJsPublicKey) {
  init(emailJsPublicKey);
} else {
  console.error('EmailJS Public Key bulunamadı. Lütfen .env dosyasını kontrol edin.');
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>
);

// Web Vitals ölçümlerini Google Analytics'e gönder
reportWebVitals(({ name, delta, id }) => {
  // Google Analytics'in yüklendiğinden emin ol
  if (window.gtag) {
    window.gtag('event', name, {
      event_category: 'Web Vitals',
      event_label: id,
      // CLS için değeri 1000 ile çarp (milisaniye cinsinden)
      value: Math.round(name === 'CLS' ? delta * 1000 : delta),
      non_interaction: true,
    });
  }
});
